// compareTo.$inject = ['$filter'];
import providerSideMenuTemplate from './views/providers-side-menu.html';
import toolboxFilterTemplate from './views/filter-toolbox.html';
import toolboxPaginationTemplate from './views/pager-toolbox.html';

function compareTo() {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function link(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = modelValue => {
                return modelValue === scope.otherModelValue;
            };
            scope.$watch("otherModelValue", () => {
                ngModel.$validate();
            });
        }
    };
}

function upperCase() {
    return {
        restrict: 'EA',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            ngModel.$parsers.push(function (value) {
                if (!value) return null;
                let newVal = value.toUpperCase();
                ngModel.$setViewValue(newVal);
                ngModel.$render();
                return newVal;
            });
            ngModel.$formatters.push(function (value) {
                if (!value || !angular.isString(value)) return;
                return value.toUpperCase();
            });
        }
    };
}

function providerSideMenu() {
    return {
        restrict: 'A',
        template: providerSideMenuTemplate
    };
}

function toolboxFilter() {
    return {
        restrict: 'A',
        template: toolboxFilterTemplate
    };
}

function toolboxPagination() {
    return {
        restrict: 'A',
        template: toolboxPaginationTemplate
    };
}

function ngEnter() {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
}

function onlyLettersInput() {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                let transformedInput = text.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g, '');
                //console.log(transformedInput);
                if (transformedInput !== text) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                }
                return transformedInput;
            }

            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}

function onlyNumbersInput() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {
                if (angular.isUndefined(inputValue)) return '';
                let transformedInput = inputValue.replace(/[^0-9]/g, '');
                if (transformedInput !== inputValue) {
                    modelCtrl.$setViewValue(transformedInput);
                    modelCtrl.$render();
                }
                return transformedInput;
            });
        }
    };
}

function checkStrength() {
    return {
        replace: false,
        restrict: 'EACM',
        link: function link(scope, iElement, iAttrs) {

            let strength;
            strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength(p) {
                    let _force = 0;
                    //let _regex = /[$-/:-?{-~!"^_`\[\]]/;
                    let _regex = /[$-/:-?-~!^_`\[\]]/;

                    let _lowerLetters = /[a-z]+/.test(p);
                    let _upperLetters = /[A-Z]+/.test(p);
                    let _numbers = /[0-9]+/.test(p);
                    let _symbols = _regex.test(p);

                    let _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    let _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + (p.length >= 10 ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = p.length <= 6 ? Math.min(_force, 10) : _force;

                    // penality (poor letiety of characters)
                    _force = _passedMatches == 1 ? Math.min(_force, 10) : _force;
                    _force = _passedMatches == 2 ? Math.min(_force, 20) : _force;
                    _force = _passedMatches == 3 ? Math.min(_force, 40) : _force;
                    return _force;
                },
                getColor: function getColor(s) {
                    let idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    } else if (s <= 20) {
                        idx = 1;
                    } else if (s <= 30) {
                        idx = 2;
                    } else if (s <= 40) {
                        idx = 3;
                    } else {
                        idx = 4;
                    }
                    return {
                        idx: idx + 1,
                        col: this.colors[idx]
                    };
                }
            }; // let strength
            scope.$watch(iAttrs.checkStrength, () => {
                if (scope.password === '') {
                    iElement.css({
                        "display": "none"
                    });
                } else {
                    if (scope.password) {
                        let c = strength.getColor(strength.mesureStrength(scope.password));
                        scope.passwordStrength = c;
                        iElement.css({
                            "display": "inline"
                        });
                        iElement.children('li').css({
                            "background": "#DDD"
                        }).slice(0, c.idx).css({
                            "background": c.col
                        });
                    }
                }
            }); // watch
        }, // link

        template: '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>'
    };
}


function currencyFormat(){
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelController) {

      var formatNumber = function(value) {

        value = value.toString();
        value = value.replace(/[^0-9\.]/g, "");
        var parts = value.split('.');
        parts[0] = parts[0].replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
        if (parts[1] && parts[1].length > 2) {
          parts[1] = parts[1].substring(0, 2);
        }

        return parts.join(".");
      };
      var applyFormatting = function() {
        var value = element.val();
        var original = value;
        if (!value || value.length == 0) {
          return
        }
        value = formatNumber(value);
        if (value != original) {
          element.val(value);
          element.triggerHandler('input')
        }
      };
      element.bind('keyup', function(e) {
        var keycode = e.keyCode;
        var isTextInputKey =
          (keycode > 47 && keycode < 58) || // number keys
          keycode == 32 || keycode == 8 || // spacebar or backspace
          (keycode > 64 && keycode < 91) || // letter keys
          (keycode > 95 && keycode < 112) || // numpad keys
          (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
          (keycode > 218 && keycode < 223); // [\]' (in order)
        if (isTextInputKey) {
          applyFormatting();
        }
      });
      element.bind('blur', function(evt) {
        if (angular.isDefined(ngModelController.$modelValue)) {
          var val = ngModelController.$modelValue.split('.');
          if (val && val.length == 1) {
            if (val != "") {
              ngModelController.$setViewValue(val + '.00');
              ngModelController.$render();
            }
          } else if (val && val.length == 2) {
            if (val[1] && val[1].length == 1) {
              ngModelController.$setViewValue(val[0] + '.' + val[1] + '0');
              ngModelController.$render();
            } else if (val[1].length == 0) {
              ngModelController.$setViewValue(val[0] + '.00');
              ngModelController.$render();
            }
            applyFormatting();
          }
        }
      })
      ngModelController.$parsers.push(function(value) {
        if (!value || value.length == 0) {
          return value;
        }
        value = value.toString();
        value = value.replace(/[^0-9\.]/g, "");
        return value;
      });
      ngModelController.$formatters.push(function(value) {
        if (!value || value.length == 0) {
          return value;
        }
        value = formatNumber(value);
        return value;
      });
    }
  };
}


export default {
    compareTo,
    ngEnter,
    upperCase,
    providerSideMenu,
    toolboxPagination,
    toolboxFilter,
    checkStrength,
    onlyLettersInput,
    onlyNumbersInput,
    currencyFormat
};



// WEBPACK FOOTER //
// ./www/components/shared/directives/directives-simple.js